// src/pages/leads/utils.js

/**
 * Convert various Firestore/JS timestamp shapes to a native Date.
 * Safe to call with null/undefined.
 */
export const toJsDate = (v) => {
  if (!v) return null;
  if (typeof v?.toDate === 'function') return v.toDate(); // Firestore Timestamp
  if (typeof v === 'number' || typeof v === 'string') {
    const d = new Date(v);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
};

/**
 * Compute the “Stage” pill for a lead based on its fields.
 * (Pure function; no React state.)
 */
export const computeStage = (lead) => {
  const statusUp = (lead?.status || '').toUpperCase();
  if (statusUp === 'CANCELLED') return 'Cancelled'; // legacy display if any old rows exist
  if (lead?.apptEndAt) return 'Finished';
  if (lead?.apptStartAt) return 'Started';
  if (lead?.sellerConfirmed) return 'Confirmed';
  if (lead?.salespersonId) return 'Assigned';
  return 'Unassigned';
};

/**
 * Chakra colorScheme for the Stage badge.
 */
export const stageColor = (stage) => {
  const up = (stage || '').toUpperCase();
  if (up === 'FINISHED') return 'green';
  if (up === 'STARTED') return 'purple';
  if (up === 'CONFIRMED') return 'cyan';
  if (up === 'ASSIGNED') return 'gray';
  if (up === 'CANCELLED') return 'red';
  return 'gray';
};

/**
 * Human-readable appointment string.
 * Keeps existing behaviour: uses Date(...).toLocaleString() when parseable.
 */
export const formatAppt = (appointment) => {
  if (!appointment) return '—';
  try {
    const d = new Date(appointment);
    return isNaN(d.getTime()) ? String(appointment) : d.toLocaleString();
  } catch {
    return String(appointment);
  }
};

/**
 * Human-readable timestamp for Firestore Timestamp or JS date-like values.
 * Keeps existing behaviour: uses toLocaleString().
 */
export const formatTs = (tsLike) => {
  try {
    if (tsLike?.toDate) return tsLike.toDate().toLocaleString(); // Firestore Timestamp
    const d = new Date(tsLike);
    return isNaN(d.getTime()) ? '—' : d.toLocaleString();
  } catch {
    return '—';
  }
};
